import React from 'react'

import ReportTable from '../report_table'
import * as Helper from '../../../../helpers/helper'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/email_finder/report_member_table.js
const MemberTableOrg = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.breakdown)
  }

  const dataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const confidenceLevelFormatter = (cell, row) => {
    return Helper.calculateConfidenceLevelTagFromScore(row.confidence_score / row.found)
  }

  const confidenceScoreFormatter = (cell, row) => {
    let score = row.confidence_score === 0 ? '0' : row.confidence_score / row.found
    return score > 0 ? score.toFixed() : 0
  }

  const getTableData = () => {
    let tableData = []
    props.memberData.forEach((data) => {
      if (data.total > 0) {
        tableData.push(data)
      }
    })
    return tableData
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('0')

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      formatter: dateFormatter,
      headerStyle: { width: '20%' },
      style: { width: '20%' },
    },
    {
      dataField: 'found',
      text: 'Total Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'not_found',
      text: 'Total Not Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'total',
      text: 'Total Request',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'duplicate',
      text: 'confidence level',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceLevelFormatter,
      align: 'right'
    },
    {
      dataField: 'confidence_score',
      text: 'Confidence Score',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceScoreFormatter,
      align: 'right'
    },
    {
      dataField: 'business',
      text: 'Business emails',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'role',
      text: 'Role emails',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'billable',
      text: 'Billable Credits',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div>
      <ReportTable
        wrapperClasses="table-member-report table-responsive"
        keyField="date"
        data={data}
        columns={columns}
        noDataIndication={dataIndication}
        hideHeader
      />
    </div>
  )
}

export default MemberTableOrg
